export const API_HOST = process.env.REACT_APP_API_HOST!
export const API_VERSION = process.env.REACT_APP_API_VERSION!
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID!
export const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET!
export const APPLE_REDIRECT_URL = process.env.REACT_APP_APPLE_REDIRECT_URL!
